import type { SVGProps } from 'react';
const SvgChannelVk = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none" {...props}>
    <path
      fill="#07F"
      d="M1.5 23.1c0-10.182 0-15.274 3.163-18.437S12.918 1.5 23.1 1.5h1.8c10.182 0 15.273 0 18.437 3.163C46.5 7.826 46.5 12.918 46.5 23.1v1.8c0 10.182 0 15.273-3.163 18.437C40.173 46.5 35.082 46.5 24.9 46.5h-1.8c-10.182 0-15.274 0-18.437-3.163C1.5 40.173 1.5 35.082 1.5 24.9z"
    />
    <path
      fill="#fff"
      d="M25.34 34.5C15.09 34.5 9.244 27.18 9 15h5.134c.169 8.94 3.954 12.727 6.952 13.508V15h4.835v7.71c2.96-.332 6.07-3.845 7.12-7.71h4.835c-.806 4.763-4.18 8.276-6.578 9.72 2.399 1.172 6.24 4.236 7.702 9.78h-5.322c-1.143-3.709-3.99-6.578-7.757-6.968V34.5z"
    />
  </svg>
);
export default SvgChannelVk;
